import React, { useContext } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import { TextField } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { globalErrorMsg, isAdFormatValid } from '@bingads-webui-campaign/hotel-common-upsert';
import { withVerticalAlignCenterSpan, Errors, getNameErrorMsg, ErrorString, validateName, checkShouldShowError, checkShouldShowErrors } from '@bingads-webui-campaign-react/wizard-shared-components';

const maxLength = 256;
export const isAdgroupNameValid = name => validateName({ name, maxLength }) == null;

export const getAdGroupNameErrorMessage = (name, adFormat) => {
  if (checkShouldShowErrors(name)) {
    return globalErrorMsg;
  }
  if (!isAdgroupNameValid(name.value)) {
    if (checkShouldShowError(name)) {
      return globalErrorMsg;
    }
  }
  if (!isAdFormatValid(adFormat)) {
    if (checkShouldShowError(adFormat)) {
      return globalErrorMsg;
    }
  }
  return '';
};

export const defaultName = undefined;

export const AdgroupName = React.memo((props) => {
  const {
    adgroupName,
    setAdgroupName,
  } = props;
  const i18n = useContext(I18nContext);
  const adgroupNameText = i18n.getString(_TL_('Ad group name'));
  const error = getNameErrorMsg({ code: validateName({ name: adgroupName.value, maxLength }), i18n, maxLength });
  const shouldShowError = checkShouldShowError(adgroupName);
  return (
    <div className={classnames('adgroup-name', 'section')}>
      <TextField
        label={adgroupNameText}
        placeholder={i18n.getString(_TL_('Enter a name for your ad group'))}
        value={adgroupName.value}
        onRenderLabel={withVerticalAlignCenterSpan(() => (<HelpPopup
          topic="pop_BA_CampaignCreate_Keywords_AdGroupName"
          aria-label={i18n.getString(_TL_('Click to learn more about {{item}}'), { item: adgroupNameText })}
        />))}
        onChange={(e, value) => {
          setAdgroupName({
            value,
            isDirty: true,
          });
        }}
        styles={{ fieldGroup: { width: 461, marginTop: '8px' } }}
      />
      {shouldShowError && error && <ErrorString error={error} />}
      {checkShouldShowErrors(adgroupName) && <Errors errors={adgroupName.errors.map(x => x.message)} />}
    </div>
  );
});

AdgroupName.propTypes = {
  adgroupName: PropTypes.string,
  setAdgroupName: PropTypes.func.isRequired,
};

AdgroupName.defaultProps = {
  adgroupName: undefined,
};
